import clsx from 'clsx';

type ColorValueProps = { label: string; value: string };

export const ColorValue = ({ label, value }: ColorValueProps) => {
  const clsLabel = clsx('c-color__label o-text--uppercase');
  const clsValue = clsx('c-color__value');

  if (!value) {
    return null;
  }

  return (
    <div className="c-color__field u-margin-bottom-md">
      <div className={clsLabel}>{label}</div>
      <div className={clsValue}>{value}</div>
    </div>
  );
};
